module.exports = __webpack_public_path__ + "img/emil-berliner-studios.55f4a369.png";